import { Label } from "../label";
import {
  ComboboxTagInput,
  type ComboboxOption,
  type ComboboxTagInputProps,
} from "../combobox-tag-input";

import { getFieldError } from "./get-field-error";
import { useFieldContext } from "./form";

interface FormComboboxTagInputProps extends Omit<
  ComboboxTagInputProps,
  "value" | "onChange"
> {
  label?: string;
  showErrorMessage?: boolean;
}

function FormComboboxTagInput({
  label,
  showErrorMessage = true,
  ...props
}: FormComboboxTagInputProps) {
  const field = useFieldContext<string[]>();

  return (
    <div className="flex flex-col gap-2">
      {label ? (
        <Label htmlFor={field.name} className="text-sm font-medium">
          {label}
        </Label>
      ) : null}
      <ComboboxTagInput
        value={field.state.value ?? []}
        onChange={(values) => field.handleChange(values)}
        {...props}
      />
      {showErrorMessage && field.state.meta.errors.length > 0 ? (
        <span className="text-sm text-destructive">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      ) : null}
    </div>
  );
}

export { FormComboboxTagInput };
export type { ComboboxOption };
